import React from 'react';
import '../styles/about.css';

function About() {
  return (
    <div className='About'>
        <div className='aboutContainer'>
            <h1 className='aboutHead'>About MovieNite</h1>
            <p className='aboutSub'>MovieNite is a web application hosted by React. It allows users to search for movies and add them to their watchlist.</p>
            <p className='aboutSub'>Users can also remove movies from their watchlist if they no longer wish to watch them.</p>
            <p className='aboutSub'>MovieNite was created by <a className="name" href="wwww.TylerGoodall.com">Tyler Goodall</a></p>
        </div>
    </div>
  );
}

export default About;
